import { BrowserRouter, useRoutes } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import Home from "./Components/Home";
import About from "./Components/About";
import Services from "./Components/Services";
import Contact from "./Components/Contact";
import GlobalStyles from "./Components/Global";

const theme = {
  color: {
    blue: "#064acb",
    red: "#e73a3a",
    white: "#ffffff",
    slate300: "hsl(203, 41%, 72%)",
    slate500: "hsl(200, 26%, 54%)",
    grey: "#e1e1e1",
    lightBlue: "#00a6e4",
    darkBlue: "#253340",
    ash: "#606060ff",
    blackText: "#1e1e1eff",
  },
  breakpoints: {
    mobile: "480px",
    tablet: "767px",
    laptop: "1070px",
  },
};

function AppRoutes() {
  return useRoutes([
    { path: "/", element: <Home /> },
    { path: "/about", element: <About /> },
    { path: "/contact", element: <Contact /> },
    { path: "/services", element: <Services /> },
  ]);
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <BrowserRouter>
        <>
          <AppRoutes />
        </>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
